import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { OcppLogMessageFormatted } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import { isOcppLogCallResultMessageStatusNotification } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.utils';
import { useTranslation } from 'react-i18next';

import { Logger } from '@app/core/logger/logger';
import { DefaultLogComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/default-log.component';

import { LogItemWrapper } from './log-item-wrapper.component';

export const StatusNotificationLogComponent = ({
  log,
}: {
  log: OcppLogMessageFormatted;
}): React.JSX.Element => {
  const { t } = useTranslation();

  if (!isOcppLogCallResultMessageStatusNotification(log.message)) {
    Logger.error(
      'Message is not of type OcppLogCallResultMessageStatusNotification',
      { log },
    );
    return <DefaultLogComponent log={log} />;
  }

  return (
    <LogItemWrapper call={log.message}>
      <Stack gap={GapEnum.S}>
        <Text bold>
          {t(
            'delmonicos-shared-sdk.ocpp-api-models-status-notification-message-request.connector-id',
          )}
        </Text>{' '}
        {log.message.parameters.connectorId}
      </Stack>
      <Stack gap={GapEnum.S}>
        <Text bold>
          {t(
            'delmonicos-shared-sdk.ocpp-api-models-status-notification-message-request.status',
          )}
        </Text>{' '}
        {log.message.parameters.status}
      </Stack>
      <Stack gap={GapEnum.S}>
        <Text bold>
          {t(
            'delmonicos-shared-sdk.ocpp-api-models-status-notification-message-request.error-code',
          )}
        </Text>{' '}
        {log.message.parameters.errorCode}
      </Stack>
    </LogItemWrapper>
  );
};
